import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {OfflineMapComponent} from './offline-map.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import {OfflineMapDiagramComponent} from './offline-map-diagram/offline-map-diagram.component';
import {DndModule} from 'ngx-drag-drop';
import {NetworkDiagramModule} from '../../utils/network-diagram/network-diagram.module';
import {EcoFabSpeedDialModule} from '@ecodev/fab-speed-dial';
import {FormsModule} from '@angular/forms';
import {OfflineMapSummaryComponent} from './offline-map-summary/offline-map-summary.component';
import {OfflineConnectionSummaryComponent} from './offline-map-summary/offline-connection-summary/offline-connection-summary.component';
import {OfflineNodeSummaryComponent} from './offline-map-summary/offline-node-summary/offline-node-summary.component';
import {OfflineNothingSelectedSummaryComponent} from './offline-map-summary/offline-nothing-selected-summary/offline-nothing-selected-summary.component';
import {OfflineMapSummaryTestRouteComponent} from './offline-map-summary/offline-nothing-selected-summary/offline-map-summary-test-route/offline-map-summary-test-route.component';
import {OfflinePeerConnectionAggregationSummaryComponent} from './offline-map-summary/offline-peer-connection-aggregation-summary/offline-peer-connection-aggregation-summary.component';
import {OfflinePeerConnectionSummaryComponent} from './offline-map-summary/offline-peer-connection-summary/offline-peer-connection-summary.component';
import {OfflineVoipPeerAggregationSummaryComponent} from './offline-map-summary/offline-voip-peer-aggregation-summary/offline-voip-peer-aggregation-summary.component';
import {OfflineVoipPeerSummaryComponent} from './offline-map-summary/offline-voip-peer-summary/offline-voip-peer-summary.component';
import {DividerModule} from '../../components/separator/divider.module';
import {AgGridModule} from 'ag-grid-angular';
import {InfoWrappersModule} from '../../utils/info-wrappers/info-wrappers.module';
import {InfraModule} from 'ac-infra';
import {HighchartModule} from '../../utils/highchart/highchart.module';
import { AddOfflineNodeDialogComponent } from './dialogs/add-offline-node-dialog/add-offline-node-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {OfflineConnectionsDialogComponent} from './dialogs/offline-connections-dialog/offline-connections-dialog.component';
import {OfflinePconsDialogComponent} from './dialogs/offline-pcons-dialog/offline-pcons-dialog.component';
import {OfflineVoipPeersDialogComponent} from './dialogs/offline-voip-peers-dialog/offline-voip-peers-dialog.component';
import {EditOfflineNodeDialogComponent} from './dialogs/edit-offline-node-dialog/edit-offline-node-dialog.component';
import {ContextMenuModule} from '@perfectmemory/ngx-contextmenu';
import {ImportNodeFromTopologyDialogComponent} from './dialogs/import-node-from-topology-dialog/import-node-from-topology-dialog.component';

@NgModule({
  declarations: [
    OfflineMapComponent,
    OfflineMapDiagramComponent,
    OfflineMapSummaryComponent,
    OfflineConnectionSummaryComponent,
    OfflineNodeSummaryComponent,
    OfflineNothingSelectedSummaryComponent,
    OfflineMapSummaryTestRouteComponent,
    OfflinePeerConnectionAggregationSummaryComponent,
    OfflinePeerConnectionSummaryComponent,
    OfflineVoipPeerAggregationSummaryComponent,
    OfflineVoipPeerSummaryComponent,
    AddOfflineNodeDialogComponent,
    OfflineConnectionsDialogComponent,
    OfflinePconsDialogComponent,
    EditOfflineNodeDialogComponent,
    OfflineVoipPeersDialogComponent,
    ImportNodeFromTopologyDialogComponent
  ],
  imports: [
    CommonModule,
    LayoutModule,
    SearchModule,
    ActionBarModule,
    MaterialModule,
    ContextMenuModule,
    DndModule,
    NetworkDiagramModule,
    EcoFabSpeedDialModule,
    FormsModule,
    DividerModule,
    AgGridModule,
    InfoWrappersModule,
    InfraModule,
    HighchartModule,
    DialogModule
  ]
})
export class OfflineMapModule { }
